import { StaticImageData } from "next/image";
import HomeHeroCard from "@/components/homeHeroSection";

type HeroProps = {
  title: string;
  desc: string;
  button: {
    link: string;
    label: string;
  };
  image: StaticImageData;
};

const Hero = (props: HeroProps) => {
  const { title, desc, button, image } = props;
  return <HomeHeroCard title={title} desc={desc} button={button} image={image.src} />;
};

export default Hero;
